import "./style.scss";
import { FC } from "react";
import BtnDefault from "../../BtnDefault/BtnDefault";
import VerticalLine from "../../VerticalLine/VerticalLine";
import { applicationPageSvgConst } from "@/src/svg/applicationsPage/applicationsPageSvgExport";
import { useDispatch, useSelector } from "react-redux";
import { toggleColumnVisibility, showAllColumns, hideAllColumns } from "@/src/store/slices/AdmissionOfficeDatabase/AODatabaseTableSlice";
import { RootState } from "@/src/store";
// import { setFilterStatus } from "@/src/store/slices/ApplicationPage/applicationsFiltersSlice";
// import { applicationPageRequests } from "@/src/api/applicationPageRequests";
import { setActualUserConfig } from "@/src/store/slices/UserOptions/userOptionsSlice";
import { admissionDatabaseAllFieldsList } from "@/src/constants/AdmissionOffice/admissionOfficeDatabaseConsts";

interface IAODHeaderProps {
  isShowSettingsModal: boolean;
  setIsShowSettingsModal: React.Dispatch<React.SetStateAction<boolean>>;
  // loadActualForm: () => void;
}

const AODHeader: FC<IAODHeaderProps> = ({
  // loadActualForm,
  isShowSettingsModal,
  setIsShowSettingsModal,
}) => {
  // const APHeader: FC = () => {
  const dispatch = useDispatch();
  // const actualSelectedRows = useSelector((state: RootState) => state.applicationsTable.selectedRows);
  const { visibleColumns } = useSelector((state: RootState) => state.AODatabaseTable);
  // const userOptions = useSelector((state: RootState) => state.userOptions);
  // const activeStatus = useSelector((state: RootState) => state.applicationsFilters.filterStatus);

  const handlers = {
    preview: () => console.log("Preview clicked"),
    comments: () => console.log("comments clicked"),
    download: () => console.log("download clicked"),
    unread: () => console.log("unread clicked"),
    admissionForward: () => console.log("admissionForward clicked"),
    tasks: () => console.log("tasks clicked"),
    move: () => console.log("move clicked"),
    delete: async () => {
      if (window.confirm("Are you sure you want to delete this item?")) {
        // await applicationPageRequests.delete(actualSelectedRows);
        // loadActualForm();
      }
    },
  };

  const handleSettingsModal = () => {
    setIsShowSettingsModal(!isShowSettingsModal);
    if (isShowSettingsModal) {
      dispatch(
        setActualUserConfig({
          AODPConfig: {
            AODPTable: visibleColumns,
            AODPFixed: "",
          },
        })
      );
    }
  };
  return (
    <div className="admission-database-header">
      <div className="admission-database-header-body">
        {/* <div className="status-tabs">
          {onlineApplicationsFilterStatusesConst.map((status) => (
            <button
              key={status}
              className={`status-tabs-item ${status === activeStatus ? "active" : ""}`}
              onClick={() => {
                dispatch(setFilterStatus(status));
              }}
            >
              {status}
            </button>
          ))}
        </div> */}
        <div className="header-actions">
          {/* {onlineApplicationsActionsConst.map((action) => (
            <BtnDefault
              onlyIcon={true}
              key={action.name}
              onClick={() => handlers[action.name as keyof typeof handlers]?.()}
            >
              <action.icon />
            </BtnDefault>
          ))}
          <VerticalLine /> */}
          <BtnDefault onlyIcon={true} onClick={() => handleSettingsModal()}>
            <applicationPageSvgConst.SettingsSvg />
          </BtnDefault>
        </div>
      </div>
      <div className={`admission-database-header-settings ${isShowSettingsModal ? "active" : ""}`}>
        <div className="admission-database-header-settings-ul">
          {admissionDatabaseAllFieldsList.map((col) => (
            <div className="admission-database-header-settings-li" key={col.id}>
              <label>
                <input
                  type="checkbox"
                  checked={visibleColumns.some((c) => c.id === col.id)}
                  onChange={() => dispatch(toggleColumnVisibility(col.id))}
                />
                {/* <span className="checkmark"></span> */}
                <div className="applications-page-header-settings-li-tab">
                  <applicationPageSvgConst.SettingsTabPlusSvg />
                  <p>{col.title}</p>
                  <applicationPageSvgConst.SettingsTabDeleteSvg />
                </div>
              </label>
            </div>
          ))}
        </div>
        <div className="applications-page-header-settings-buttons">
          <div className="applications-page-header-settings-buttons-both">
            <BtnDefault onClick={() => dispatch(showAllColumns())}>
              <p>Choose all</p>
              <applicationPageSvgConst.ChooseAllSvg />
            </BtnDefault>
            <BtnDefault onClick={() => dispatch(hideAllColumns())}>
              <p>Clear all</p>
              <applicationPageSvgConst.ClearAllSvg />
            </BtnDefault>
          </div>
          <VerticalLine />
          <div className="applications-page-header-settings-buttons-save">
            <BtnDefault reverse={true} onClick={handleSettingsModal}>
              <p>Save</p>
              <applicationPageSvgConst.SaveSvg />
            </BtnDefault>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AODHeader;
